import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import ScrollToTop from 'react-router-scroll-top';

import { AuthState } from './context/auth/AuthState';
import { ApiState } from './context/api/ApiState';

import App from './App';
import history from './history';
import './styles/main_global.scss';

render((
	<Router history={history}>
		<ScrollToTop>
			<AuthState>
				<ApiState>
					<App />
				</ApiState>
			</AuthState>
		</ScrollToTop>
	</Router>
), document.getElementById('root'));